<template>
  <v-container
    class="grey lighten-5"
    style="max-width: 80%; margin-top: 15%; padding: 0; border-radius: 8px"
  >
    <!-- <v-row  no-gutters> -->
    <v-img
      style="margin: auto; margin-top: 120px"
      :src="image"
      width="200"
    ></v-img>
    <!-- </v-row> -->
    <v-row>
      <span class="font-weight-black" style="margin: auto">ยินดีต้อนรับ</span>
    </v-row>
    <v-row>
      <span style="margin: auto">กรุณารอสักครู่</span>
    </v-row>
    <!-- <v-row>
      <span v-if="errorStr" style="margin: auto">
        Sorry, but the following error occurred: {{ errorStr }}
      </span>
    </v-row>
    <v-row>
      <span v-if="gettingLocation" style="margin: auto">
        <i>Getting your location...</i>
      </span>
    </v-row> -->
    <v-row no-gutters>
      <v-progress-circular
        :width="3"
        style="margin: auto"
        color="red"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
import image from "@/assets/Logo.png";
import * as browser from "@/ultils/browser";
import liffHelper from "@/ultils/helper/liftHelper";
import regisApi from "@/services/api/regis";
export default {
  data: () => ({
    image: image,
    data: null,
    location: null,
    gettingLocation: false,
    errorStr: null,
  }),
  async created() {
    this.data = this.$store.getters.getData;

    // if (!("geolocation" in navigator)) {
    //   this.errorStr = "Geolocation is not available.";
    //   return;
    // }

    // this.gettingLocation = true;
    // try {
    //   let pos = await this.getLocation();
    //   this.gettingLocation = false;
    //   this.location = pos;
    // } catch (err) {
    //   this.gettingLocation = false;
    //   this.errorStr = err.message;
    // }
    // if (this.location) {
    //   this.data["lat"] = this.location.coords.latitude;
    //   this.data["lng"] = this.location.coords.longitude;
    // }
    await this.redirect();
  },
  methods: {
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          }
        );
      });
    },
    async redirect() {
      // alert("test");
      if (this.$route.query.uri !== undefined) {
        //   alert("test2");
        await regisApi.saveLog(this.data);
        if (browser.checkLine()) {
          //  alert("test3");
          if (!browser.getOS()) {
            // alert("test4");
            // alert(this.$route.query.uri);
            // alert("test5");
            // alert(this.data.uri);
            liffHelper.openWindow(this.$route.query.uri, false);
            liffHelper.closeWindow();
          } else {
            window.location.href = this.$route.query.uri;
          }
        } else {
          window.location.href = this.$route.query.uri;
        }
        //   window.location.href = this.$route.query.uri;
      } else if (this.$route.query.add !== undefined) {
        await regisApi.saveLogCustom(this.data);
        window.location = `line://oaMessage/@835nlrok/?`;
      }
    },
  },
};
</script>